import { useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import useQuery from 'hooks/useQuery'
import { filterEmptyValues } from 'utils/helpers'
import { AggregatorDropdown, Button, TextInput } from 'components/common'
import { ORDER_TABLE_FIELDS } from 'utils/constants'
import { CustomObject } from 'types/common'
import { FILTER_FIELD_ORDERS } from './utils'
import { DateTime } from 'components/common/input/dateTime'
import dayjs from 'dayjs'

const { ORDER_NO, AGGREGATOR_CODE, PREPARED_BY, STATUS } = ORDER_TABLE_FIELDS

type Props = {
  toggleFilterForm: () => void
}

const OrdersByStoreFilterForm = ({ toggleFilterForm }: Props) => {
  const { getQuery, removeQuery, setMultipleQueries } = useQuery()
  const filters = getQuery(FILTER_FIELD_ORDERS)

  const [resetFilter, setResetFilter] = useState(false)

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: filters,
  })

  const onFilterApply = (data: CustomObject) => {
    if (data?.[AGGREGATOR_CODE.value] === 'NONE') {
      delete data[AGGREGATOR_CODE.value]
    }

    const filteredData = filterEmptyValues(data)

    if (Object.values(filteredData).length > 0) {
      setMultipleQueries({ [FILTER_FIELD_ORDERS]: filteredData, page: 1 })
    } else {
      removeQuery(FILTER_FIELD_ORDERS)
    }

    toggleFilterForm()
  }

  const cancelFilter = () => {
    reset(filters)
    setResetFilter((pre) => !pre)
    toggleFilterForm()
  }

  const { beforeMonth, today } = useMemo(
    () => ({
      beforeMonth: dayjs().subtract(30, 'days').format('YYYY-MM-DD'),
      today: dayjs().format('YYYY-MM-DD'),
    }),
    [],
  )

  return (
    <div className="mt-2 rounded-lg border bg-white px-5 py-3 ">
      <div className="mx-auto max-w-5xl">
        <form onSubmit={handleSubmit(onFilterApply)}>
          <div className="grid gap-x-14 gap-y-3 md:grid-cols-3">
            {/* ORDER_NO */}
            <TextInput
              register={register}
              name={ORDER_NO.value}
              label={ORDER_NO.label}
            />
            {/* Channel */}
            <AggregatorDropdown
              withNoneOption
              setValue={setValue}
              defaultValue={filters?.[AGGREGATOR_CODE.value] || resetFilter}
              name={AGGREGATOR_CODE.value}
              label={AGGREGATOR_CODE.label}
            />
            <TextInput
              register={register}
              name={STATUS.value}
              label={STATUS.label}
            />
            <TextInput
              register={register}
              name={PREPARED_BY.value}
              label={PREPARED_BY.label}
            />
            <DateTime
              label={'Orders From'}
              name={'from'}
              register={register}
              max={today}
              min={beforeMonth}
              error={errors?.from?.message as string}
            />

            <DateTime
              label={'Orders To'}
              name={'to'}
              register={register}
              max={today}
              min={beforeMonth}
              error={errors?.to?.message as string}
            />
          </div>
          <div className="my-4 flex gap-5">
            <Button buttonText="Apply Filters" className="w-32" />

            <Button
              buttonText="cancel"
              variant="outline"
              type="button"
              onClick={cancelFilter}
              className="w-32"
            />
          </div>
        </form>
      </div>
    </div>
  )
}

export default OrdersByStoreFilterForm
